import React from 'react';

import {
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';

const Forbidden = () => {
  const { t } = useTranslation();
  return (
    <div className="GenericPage">
      <h1>{t('pages.403.title')}</h1>
      <p>{t('pages.403.body')}</p>
      <div className="GenericPage__links">
        <Button primary href={t('pages.403.primary_button.url')} className="icon-after icon-arrow-right icon-variant-1">{t('pages.403.primary_button.link')}</Button>
        <Button secondary href={t('pages.403.secondary_button.url')} className="Button Button--secondary icon-after icon-arrow-right icon-variant-2">{t('pages.403.secondary_button.link')}</Button>
      </div>
    </div>
  );
};

export default Forbidden;
